/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LabeledInput from '../../../components/LabeledInput';
import LabeledSelect from '../../../components/LabeledSelect';
import { Button, Row, Col} from "react-bootstrap";
import { useForm, FormProvider } from 'react-hook-form';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../../components/Loader';
import { updateCompany, getCompanyById, getAllBanks } from '../../../middleware/backend_hepler';

const EditCompanyForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);

  const methods = useForm({
    defaultValues: {
      company_name: "",
      bank_list: "",
      company_pincode: "",
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      
      if (id) {
        try {
          const response = await getCompanyById(id);
          const companyData = response.data;
          setValue("company_name", companyData.company_name || "");
          setValue("bank_list", companyData.bank_list || "");        
          setValue("company_pincode", companyData.company_pincode || "");
        } catch (error) {
          console.error("Failed to fetch data:", error);
          setError(error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, setValue]);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await getAllBanks();
        const banksData = response.data.map((bank) => ({
          value: bank.bank_id,
          label: bank.bank_name,
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setBanks(banksData);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };
    fetchBanks();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await updateCompany(id, data);
      navigate("/companylist", {
        state: { successMessage: "Company updated successfully!" },
      });
    } catch (error) {
      setLoading(false);
      console.error("Error for company creation:", error);
      toast.error("Failed to create company. Please try again.");
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      <div className="edit-back-icon">
        <div
          className="edit-back-text"
          onClick={() => navigate("/companylist")}
        >
          &lt; Go Back
        </div>
      </div>
      <h2>Company</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="sections personal-details-sections">
            <h4>Company Details</h4>
            <Row>
              <Col md={6}>
                <LabeledInput
                  name="company_name"
                  label="Company Name"
                  registerOptions={{ required: "Company Name is required" }}
                  required
                />
              </Col>
              <Col md={6}>
                <LabeledInput
                  name="company_pincode"
                  label="Company Pincode"
                />
              </Col>
              <Col md={6}>
                <LabeledSelect
                  name="bank_list"
                  label="Bank List"
                  isMulti={true}
                  options={banks}
                  registerOptions={{
                    required: "Bank List is required",
                  }}
                />
              </Col>
            </Row>
          </div>
          <div className="button-container mt-4 text-center">
            <Button
              variant="success"
              type="submit"
              className="custom-submit-button"
            >
              Submit
            </Button>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditCompanyForm;
